import FolderSharedRoundedIcon from "@mui/icons-material/FolderSharedRounded";
import ReceiptRoundedIcon from '@mui/icons-material/ReceiptRounded';
import FileOpenRoundedIcon from "@mui/icons-material/FileOpenRounded";
import {
  Autocomplete,
  Box,
  Button,
  Divider,
  Grid,
  Modal,
  Paper,
  Switch,
  TextField,
  Typography,
  styled,
  Tabs,
  Tab,
  Chip
} from "@mui/material";
import Avatar from "@mui/material/Avatar";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { decode } from "base-64";
import { useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api } from "../api";
import { fetchToken } from "../auth/Token";
import "../card.css";
import PropTypes from 'prop-types';
import { CircularProgressWithLabel, GroupLoanPerformance } from "./SocietyManagerPage";


const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(2),
  borderStyle: "groove",
  border: "3px",
  borderColor: "grey",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2), 0 6px 20px rgba(0, 0, 0, 0.2)",
  marginTop: "10px",
  minHeight: "50px",
  borderRadius: "10px",
}));

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export const SocietyLoans = (isOnline) => {
    const location = useLocation();
    const society_id = location.state && location.state.society_id;
    const society_name = location.state && location.state.name;
    const [loans, setLoans] = useState([]);
    const [viewPerformance, setViewPerformance] = useState(false);
    const [viewPV, setViewPV] = useState(false);
    const [loan_data, setLoan_data] = useState([]);
    const [value1, setValue1] = useState(0);

    const currencyFormat = new Intl.NumberFormat('en-GH', {
        style: 'currency',
        currency: 'GHS',
      });

    const handleChange1 = (event, newValue) => {
      setValue1(newValue);
    };

    const handleClosePerformance = () => {
        setViewPerformance(false);
    }
    
    const handleClosePV = () => {
        setViewPV(false);
    }

    const handleOpenPerformance = (row) => {
        setViewPerformance(true);
        setLoan_data(row)
    }
    
    const handleOpenPV = (row) => {
        setViewPV(true);
        setLoan_data(row)
    }

    
    const printRef = React.useRef();

    const handlePrint = async () => {
        const element = printRef.current;
        const canvas = await html2canvas(element);
        const data = canvas.toDataURL('image/png');
    
        const pdf = new jsPDF();
        const imgProperties = pdf.getImageProperties(data);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProperties.height * pdfWidth) / imgProperties.width;
    
        const pageHeight = pdf.internal.pageSize.getHeight();
        const marginLeft = 10;
        const marginTop = 10;
        const marginRight = 10;
        const marginBottom = 10;
        let yOffset = 0;
        let pageNumber = 1;
    
        while (yOffset < pdfHeight) {
            if (pageNumber > 1) {
                pdf.addPage();
            }
    
            pdf.addImage(
                data,
                'PNG',
                marginLeft,
                marginTop - yOffset,
                pdfWidth - marginLeft - marginRight,
                pdfHeight - marginTop - marginBottom
            );
    
            // Add page label
            pdf.setFontSize(8);  // Make the font size smaller
        pdf.text(`Page ${pageNumber}`, marginLeft - 9, pageHeight - marginBottom + 5);
    
            yOffset += pageHeight - marginTop - marginBottom;
            pageNumber++;
        }
    
        pdf.save('PV.pdf');
    };



    function formatDateToYearMonthDay(date) {
        const months = [
          "Jan", "Feb", "Mar", "Apr", "May", "Jun",
          "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
        ];
        const day = date.getDate();
        const month = months[date.getMonth()];
        const year = date.getFullYear();
        let suffix = "th";
        if (day === 1 || day === 21 || day === 31) suffix = "st";
        else if (day === 2 || day === 22) suffix = "nd";
        else if (day === 3 || day === 23) suffix = "rd";
        return `${day}${suffix} ${month} ${year}`;
    }
    

  const getMyData = () => {
    const data = new FormData();
    data.append("society_id", society_id);

    toast.promise(
        api.post("/association/society/loans/data", data, {
          headers: {
            Authorization: "Bearer " + fetchToken(),
            "Content-Type": "multipart/form-data",
          },
        }),
        {
          loading: "Loading Loans",
          success: (response) => {
            setLoans(response.data);
            
            return "Loans Loaded Successfully";
          },
          error: (error) => {
            console.error(error);
            return 'Error, please try again';
          },
        }
    );
}

useEffect(() => {
    getMyData();
},[])

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    // width: "90%",
    maxHeight: "80vh",
    minHeight: "70vh",
    overflowY: "auto",
    "&::-webkit-scrollbar": {
      width: "7px",
    },
    "&::-webkit-scrollbar-track": {
      background: "#f1f1f1",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#888",
      borderRadius: "10px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#555",
    },
    bgcolor: "background.paper",
    borderRadius: "7px",
    boxShadow: 24,
    p: 4,
  };

  

  return (
    <div className="app">
      <main className="content">
        <Box sx={{ m: 3 }}>
          <Typography
            sx={{ textAlign: "center" }}
            variant="h4"
            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
          >
            <b>{society_name}'s Loans</b>
          </Typography>
          
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <Tabs value={value1} onChange={handleChange1} aria-label="basic tabs example">
                <Tab label={<b style={{ fontStyle: 'normal', fontFamily:"'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" }}>All Loans</b>} {...a11yProps(0)} />
                <Tab label={<b style={{ fontStyle: 'normal', fontFamily:"'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif" }}>Grouped Loans</b>} {...a11yProps(1)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={value1} index={0}>
                <Box
                    sx={{
                    overflow: "auto",
                    marginBottom: 10,
                    maxHeight: 340,
                    "&::-webkit-scrollbar": {
                        width: "7px",
                        height: "7px",
                    },
                    "&::-webkit-scrollbar-track": {
                        background: "#f1f1f1",
                    },
                    "&::-webkit-scrollbar-thumb": {
                        background: "#888",
                        borderRadius: "10px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                        background: "#555",
                    },
                    }}
                >
                    {!loans?.loans ? (
                    <Typography
                        sx={{ m: 1 }}
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                        <b>No Individual Loans Available</b>
                    </Typography>
                    ) : null}

                    <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                        <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>No.</b>
                            </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Request Date</b>
                            </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Loan Product</b>
                            </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Amount</b>
                            </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Member</b>
                            </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Savings Group</b>
                            </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Group Name</b>
                            </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Passbook</b>
                            </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Level</b>
                            </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Status</b>
                            </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Notes</b>
                            </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>PV</b>
                            </Typography>{" "}
                        </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loans?.loans?.map((row, index) => (
                        <TableRow
                            key={row.index}
                            sx={{
                            "&:last-child td, &:last-child th": {
                                border: 0,
                            },
                            backgroundColor: "#f5f3f4",
                            }}
                        >
                            <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{index + 1}</b>
                            </Typography>
                            </TableCell>
                            <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{formatDateToYearMonthDay(new Date(row.transaction_date))}</b>
                            </Typography>
                            </TableCell>
                            <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{row.account_name}</b>
                            </Typography>
                            </TableCell>
                            <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{currencyFormat.format(row.amount)}</b>
                            </Typography>
                            </TableCell>
                            <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{row.member_name}</b>
                            </Typography>
                            </TableCell>
                            <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{row.association_name}</b>
                            </Typography>
                            </TableCell>
                            <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{row.group_name}</b>
                            </Typography>
                            </TableCell>
                            <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{row.passbook}</b>
                            </Typography>
                            </TableCell>
                            <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{row.level_name} ({row.level})</b>
                            </Typography>
                            </TableCell>
                            <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{row.status}</b>
                            </Typography>
                            </TableCell>
                            <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <Button
                                    size="small"
                                    color="success"
                                    variant="contained"
                                    sx={{
                                    borderRadius: 2,
                                    boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    "&:hover": {
                                        boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                    },
                                    }}
                                    onClick={() => handleOpenPerformance(row)}
                                >
                                    <FileOpenRoundedIcon />
                                </Button>
                            </Typography>
                            </TableCell>
                            <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <Button
                                    size="small"
                                    color="success"
                                    variant="contained"
                                    disabled={row.level === 'Team' || row.level === 'Credit Officer'}
                                    sx={{
                                    borderRadius: 2,
                                    boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    "&:hover": {
                                        boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                    },
                                    }}
                                    onClick={() => handleOpenPV(row)}
                                >
                                    <ReceiptRoundedIcon />
                                </Button>
                            </Typography>
                            </TableCell>
                            
                        </TableRow>
                        ))}
                    </TableBody>
                    </Table>
                </Box>
            </CustomTabPanel>
            <CustomTabPanel value={value1} index={1}>
            <Box
                    sx={{
                    overflow: "auto",
                    marginBottom: 10,
                    maxHeight: 340,
                    "&::-webkit-scrollbar": {
                        width: "7px",
                        height: "7px",
                    },
                    "&::-webkit-scrollbar-track": {
                        background: "#f1f1f1",
                    },
                    "&::-webkit-scrollbar-thumb": {
                        background: "#888",
                        borderRadius: "10px",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                        background: "#555",
                    },
                    }}
                >
                    {!loans?.loans ? (
                    <Typography
                        sx={{ m: 1 }}
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                        <b>No Individual Loans Available</b>
                    </Typography>
                    ) : null}

                    <Table size="small" aria-label="a dense table">
                    <TableHead>
                        <TableRow>
                        <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>No.</b>
                            </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Request Date</b>
                            </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Group Name</b>
                            </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Loan Product</b>
                            </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Total Amount</b>
                            </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Total Member</b>
                            </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Savings Group</b>
                            </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Level</b>
                            </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Status</b>
                            </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Details/Notes</b>
                            </Typography>{" "}
                        </TableCell>
                        <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>PV</b>
                            </Typography>{" "}
                        </TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {loans?.group_loans?.map((row, index) => (
                        <TableRow
                            key={row.index}
                            sx={{
                            "&:last-child td, &:last-child th": {
                                border: 0,
                            },
                            backgroundColor: "#f5f3f4",
                            }}
                        >
                            <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{index + 1}</b>
                            </Typography>
                            </TableCell>
                            <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{formatDateToYearMonthDay(new Date(row.transaction_date))}</b>
                            </Typography>
                            </TableCell>
                            <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{row.group_name}</b>
                            </Typography>
                            </TableCell>
                            <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{row.account_name}</b>
                            </Typography>
                            </TableCell>
                            <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{currencyFormat.format(row.amount)}</b>
                            </Typography>
                            </TableCell>
                            <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{row.group_performance?.member_count}</b>
                            </Typography>
                            </TableCell>
                            <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{row.association_name}</b>
                            </Typography>
                            </TableCell>
                            <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{row.level}</b>
                            </Typography>
                            </TableCell>
                            <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{row.status}</b>
                            </Typography>
                            </TableCell>
                            <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <Button
                                    size="small"
                                    color="success"
                                    variant="contained"
                                    sx={{
                                    borderRadius: 2,
                                    boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    "&:hover": {
                                        boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                    },
                                    }}
                                    onClick={() => handleOpenPerformance(row)}
                                >
                                    <FileOpenRoundedIcon />
                                </Button>
                            </Typography>
                            </TableCell>
                            <TableCell align="left">
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <Button
                                    size="small"
                                    color="success"
                                    variant="contained"
                                    sx={{
                                    borderRadius: 2,
                                    boxShadow:
                                        "0 4px 8px rgba(0, 0, 0, 0.1), 0 8px 20px rgba(0, 0, 0, 0.1)",
                                    "&:hover": {
                                        boxShadow:
                                        "0 8px 12px rgba(0, 0, 0, 0.2), 0 8px 30px rgba(0, 0, 0, 0.2)",
                                        backgroundColor: "#14213d",
                                    },
                                    }}
                                    onClick={() => handleOpenPV(row)}
                                >
                                    <ReceiptRoundedIcon />
                                </Button>
                            </Typography>
                            </TableCell>
                            
                        </TableRow>
                        ))}
                    </TableBody>
                    </Table>
                </Box>
            </CustomTabPanel>
        </Box>
        <Modal
            open={viewPerformance}
            onClose={handleClosePerformance}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Grid container spacing={1}>
                <Grid item xs={12} md={12}>
                  <Typography 
                    variant="h3" 
                    sx={{ 
                      mb: 2,
                      textAlign: 'center',
                      color: '#2c3e50'
                    }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                  >
                    <b>Notes</b>
                  </Typography>
                </Grid>
                {
                  loan_data.request_type === "Loan"?
                  <Grid item xs={12} md={12}>
                    {loan_data.notes.length > 0 ? (
                        loan_data.notes.map((note, index) => (
                        <Paper key={index} sx={{ p: 2, mb: 2, borderRadius: '8px' }}>
                            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                            <Typography 
                                fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                                sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}
                            >
                                <b>{note.title}</b>
                            </Typography>
                            <Typography variant="body2" fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{new Date(note.date).toLocaleDateString()} by {note.user_name}</b>
                            </Typography>
                            </Box>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{note.note}</b>
                            </Typography>
                        </Paper>
                        ))
                    ) : (
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>No notes available for this group loan.</b>
                        </Typography>
                    )}
                </Grid>
                  :null
                }
                {
                  loan_data.request_type === "Group Loan"?
                    <Grid item xs={12} md={12}>
                      <GroupLoanPerformance groupLoan={loan_data} />
                    </Grid>
                  :null
                }
              </Grid>
            </Box>
          </Modal>
          
          <Modal
            open={viewPV}
            onClose={handleClosePV}
            aria-labelledby="payment-voucher-modal"
            >
            <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: { xs: '95%', sm: '80%', md: '60%' },
                maxWidth: '800px',
                bgcolor: 'background.paper',
                boxShadow: 24,
                p: 3,
                borderRadius: 2,
                maxHeight: '90vh',
                overflowY: 'auto'
            }}>
                <div ref={printRef}>
                {/* Voucher Header */}
                <Box sx={{ 
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 3,
                borderBottom: '2px solid #f0f0f0',
                pb: 2
                }}>
                <Box>
                    <Typography 
                    variant="h4" 
                    sx={{ color: '#2c3e50' }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                    <b>PAYMENT VOUCHER</b>
                    </Typography>
                    <Typography 
                    variant="body2"
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                    <b>Date: {new Date().toLocaleDateString()}</b>
                    </Typography>
                </Box>
                <Box sx={{ textAlign: 'right' }}>
                    <Typography 
                    variant="h6"
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                    <b>Voucher #: PV-{loan_data?.transaction_id || loan_data?.id}</b>
                    </Typography>
                    <Chip 
                    label={loan_data?.status || 'Pending'} 
                    color={
                        loan_data?.status === 'Disbursed' ? 'success' :
                        loan_data?.status === 'Approved' ? 'primary' :
                        loan_data?.status === 'Rejected' ? 'error' : 'default'
                    }
                    size="small"
                    />
                </Box>
                </Box>

                {/* Payee Information */}
                <Box sx={{ 
                p: 2,
                mb: 3,
                border: '1px solid #f0f0f0',
                borderRadius: 1,
                backgroundColor: '#f9f9f9'
                }}>
                <Typography 
                    variant="h6"
                    sx={{ mb: 1, textDecoration: 'underline' }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                    <b>Payee Details</b>
                </Typography>
                
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Name: {loan_data?.member_name || loan_data?.group_name}</b>
                    </Typography>
                    {
                        loan_data?.request_type === "Loan"?
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Phone: {loan_data?.member_phone || 'N/A'}</b>
                        </Typography>
                        :null
                    }
                    
                    </Grid>
                    <Grid item xs={12} md={6}>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Saving Group: {loan_data?.association_name}</b>
                    </Typography>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Community: {loan_data?.community_name}</b>
                    </Typography>
                    </Grid>
                </Grid>
                </Box>

                {/* Payment Details */}
                <Box sx={{ 
                p: 2,
                mb: 3,
                border: '1px solid #f0f0f0',
                borderRadius: 1
                }}>
                <Typography 
                    variant="h6"
                    sx={{ mb: 1, textDecoration: 'underline' }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                >
                    <b>Payment Details</b>
                </Typography>
                
                <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Account: {loan_data?.account_name}</b>
                    </Typography>
                    <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Transaction Date: {new Date(loan_data?.transaction_date).toLocaleDateString()}</b>
                    </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                    {
                        loan_data?.request_type === "Loan"?
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Requested Amount: {currencyFormat.format(loan_data?.amount)}</b>
                        </Typography>
                        :
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>Total Amount: {currencyFormat.format(loan_data?.amount)}</b>
                        </Typography>
                    }
                    
                    {loan_data?.recommended_amount && (
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Recommended Amount: {currencyFormat.format(loan_data.recommended_amount)}</b>
                        </Typography>
                    )}
                    </Grid>
                </Grid>
                </Box>

                {/* Savings Information (for individual loans) */}
                {loan_data?.request_type === "Loan" && loan_data?.savings_account_list?.length > 0 && (
                <Box sx={{ 
                    p: 2,
                    mb: 3,
                    border: '1px solid #f0f0f0',
                    borderRadius: 1,
                    backgroundColor: '#f9f9f9'
                }}>
                    <Typography 
                    variant="h6"
                    sx={{ mb: 1, textDecoration: 'underline' }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                    <b>Savings Accounts</b>
                    </Typography>
                    
                    <Grid container spacing={2}>
                    {loan_data.savings_account_list.map((account, index) => (
                        <Grid item xs={12} key={index}>
                        <Box sx={{ 
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            p: 1,
                            borderBottom: '1px solid #eee'
                        }}>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                            <b>{account.account_name}</b>
                            </Typography>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                            <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                                <b>{currencyFormat.format(account.current_balance)}</b>
                            </Typography>
                            <Chip 
                                label={account.savings_performance.performance_rating}
                                size="small"
                                color={
                                account.savings_performance.performance_rating === 'Excellent' ? 'success' :
                                account.savings_performance.performance_rating === 'Good' ? 'primary' :
                                account.savings_performance.performance_rating === 'Fair' ? 'warning' : 'error'
                                }
                            />
                            </Box>
                        </Box>
                        </Grid>
                    ))}
                    </Grid>
                </Box>
                )}

                {/* Group Loan Summary (for group loans) */}
                {loan_data?.request_type === "Group Loan" && (
                <Box sx={{ 
                    p: 2,
                    mb: 3,
                    border: '1px solid #f0f0f0',
                    borderRadius: 1
                }}>
                    <Typography 
                    variant="h6"
                    sx={{ mb: 1, textDecoration: 'underline' }}
                    fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                    <b>Group Summary</b>
                    </Typography>
                    
                    <Grid container spacing={2}>
                    <Grid item xs={12} md={6}>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Total Members: {loan_data.group_performance.member_count}</b>
                        </Typography>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Average Savings Consistency: {loan_data.group_performance.average_consistency}%</b>
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <Typography fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif">
                        <b>Group Performance:{loan_data.group_performance.performance_rating}</b> 
                        </Typography>
                    </Grid>
                    </Grid>
                </Box>
                )}

                {/* Approval Section */}
                <Box sx={{ 
                mt: 4,
                pt: 2,
                borderTop: '2px dashed #ccc'
                }}>
                {
                    loan_data?.level === "Society Manager"?
                    <Grid container spacing={2}>
                    <Grid item xs={12} md={4}>
                      <Box sx={{
                          p: 1,
                          borderBottom: '1px solid #ccc',
                          textAlign: 'center'
                      }}>
                          <Typography 
                            variant="body2"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>Prepared By(Operations Manager)</b>
                          </Typography>
                          <Box sx={{ height: '60px', mt: 1 }}></Box>
                          <Typography 
                            variant="body2"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>{loan_data.op}</b>
                          </Typography>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Box sx={{
                          p: 1,
                          borderBottom: '1px solid #ccc',
                          textAlign: 'center'
                      }}>
                          <Typography 
                            variant="body2"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>Approved By</b>
                          </Typography>
                          <Box sx={{ height: '60px', mt: 1 }}></Box>
                      </Box>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Box 
                        sx={{ 
                          p: 1,
                          borderBottom: '1px solid #ccc',
                          textAlign: 'center'
                        }}
                      >
                          <Typography 
                            variant="body2"
                            fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                          >
                            <b>Disburse By</b>
                          </Typography>
                          <Box sx={{ height: '60px', mt: 1 }}></Box>
                      </Box>
                    </Grid>
                </Grid>
                : loan_data?.level === "Operations Manager"?
                <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <Box 
                    sx={{ 
                      p: 1,
                      borderBottom: '1px solid #ccc',
                      textAlign: 'center'
                    }}
                  >
                      <Typography 
                        variant="body2"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>Prepared By</b>
                      </Typography>
                      <Box sx={{ height: '60px', mt: 1 }}></Box>
                  </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Box sx={{ 
                    p: 1,
                    borderBottom: '1px solid #ccc',
                    textAlign: 'center'
                  }}>
                      <Typography 
                        variant="body2"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>Approved By</b>
                      </Typography>
                      <Box sx={{ height: '60px', mt: 1 }}></Box>
                  </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Box sx={{ 
                      p: 1,
                      borderBottom: '1px solid #ccc',
                      textAlign: 'center'
                  }}>
                      <Typography 
                      variant="body2"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                      <b>Disburse By</b>
                      </Typography>
                      <Box sx={{ height: '60px', mt: 1 }}></Box>
                  </Box>
                </Grid>
            </Grid>
                :loan_data?.level === "Cashier"?
                <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <Box sx={{
                      p: 1,
                      borderBottom: '1px solid #ccc',
                      textAlign: 'center'
                  }}>
                      <Typography 
                        variant="body2"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>Prepared By(Operations Manager)</b>
                      </Typography>
                      <Box sx={{ height: '60px', mt: 1 }}></Box>
                      <Typography 
                        variant="body2"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>{loan_data.op}</b>
                      </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Box sx={{
                      p: 1,
                      borderBottom: '1px solid #ccc',
                      textAlign: 'center'
                  }}>
                      <Typography 
                        variant="body2"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>Approved By(Society Manager)</b>
                      </Typography>
                      <Box sx={{ height: '60px', mt: 1 }}></Box>
                      <Typography 
                        variant="body2"
                        fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                      >
                        <b>{loan_data.sm}</b>
                      </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Box
                    sx={{
                      p: 1,
                      borderBottom: "1px solid #ccc",
                      textAlign: "center",
                    }}
                  >
                    <Typography
                      variant="body2"
                      fontFamily="'Nunito', 'Outfit', 'Roboto', 'Source Sans 3', sans-serif"
                    >
                      <b>Disburse By</b>
                    </Typography>
                    <Box sx={{ height: "60px", mt: 1 }}></Box>
                  </Box>
                </Grid>
              </Grid>
                :null
                }
                </Box>
                </div>
                {/* Print Button */}
                <Box sx={{ 
                mt: 3,
                display: 'flex',
                justifyContent: 'flex-end'
                }}>
                <Button 
                    variant="contained" 
                    onClick={handlePrint}
                    sx={{ mr: 2 }}
                >
                    Print Voucher
                </Button>
                <Button 
                    variant="outlined" 
                    onClick={handleClosePV}
                >
                    Close
                </Button>
                </Box>
            </Box>
            </Modal>

        
        </Box>
      </main>
    </div>
  );
};
